export default "__VITE_ASSET__CR5qF_Z7__"